import {
  createFeatureSelector,
  MemoizedSelector,
  createSelector
} from '@ngrx/store';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';
import { SearchResultModel } from 'datastop-io-autocomplete-library-1/lib/models/search/search-result.model';

import * as MajorFeatureState from './major.state';

export const majorStateSlice: MemoizedSelector<
  object,
  MajorFeatureState.MajorState
> = createFeatureSelector<MajorFeatureState.MajorState>(
  MajorFeatureState.majorFeatureKey
);

export const getSearchResultModel: MemoizedSelector<object, SearchResultModel> =
  createSelector(majorStateSlice, (state): SearchResultModel => {
    if (state.majorModel) {
      return {
        id: state.majorModel.CipCode,
        name: state.majorModel.Major,
        data: null
      };
    }

    return null;
  });

export const getOccupationList: MemoizedSelector<
  object,
  OccupationQuickMatchModel[]
> = createSelector(majorStateSlice, MajorFeatureState.selectAll);
